<template>
  <slot v-if="!error" />
  <div
    v-else
    class="flex flex-col items-center justify-center min-h-[60vh] gap-4 px-4 text-center"
    role="alert"
  >
    <h2 class="text-xl font-semibold text-foreground">Something went wrong</h2>
    <p class="text-muted-foreground max-w-md">
      This page encountered an unexpected error. Try reloading or navigate to another section.
    </p>
    <button
      class="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-ring transition-colors"
      @click="reload"
    >
      Reload page
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onErrorCaptured } from 'vue'
import { useRoute } from 'vue-router'
import { reportError } from '@/error-tracking'

const error = ref(false)
const route = useRoute()

onErrorCaptured((err) => {
  reportError(err as Error, { source: 'RouteErrorBoundary', path: route.path })
  error.value = true
  return false
})

watch(() => route.path, () => {
  error.value = false
})

function reload() {
  window.location.reload()
}
</script>
